import { BaseApi } from './base.api.js';

export class SystemLogsApi extends BaseApi {
    constructor(client) {
        super(client, '/system-logs');
    }

    async getStatSummary(params = {}) {
        const response = await this.client.get(`${this.basePath}/stat-summary`, { params });
        return response.data;
    }

    async getStats(params = {}) {
        const response = await this.client.get(`${this.basePath}/stats`, { params });
        return response.data;
    }

    async getHeatmap(params = {}) {
        const response = await this.client.get(`${this.basePath}/heatmap`, { params });
        return response.data;
    }

    async getSecuritySummary() {
        const response = await this.client.get(`${this.basePath}/security-summary`);
        return response.data;
    }

    async getRetentionInfo() {
        const response = await this.client.get(`${this.basePath}/retention-info`);
        return response.data;
    }

    async getUserActivity(userId, params = {}) {
        const response = await this.client.get(`${this.basePath}/user-activity/${userId}`, { params });
        return response.data;
    }

    async getDeltaPicker(params = {}) {
        const response = await this.client.get(`${this.basePath}/delta-picker`, { params });
        return response.data;
    }

    async getTimeline(resourceType, resourceId, params = {}) {
        const rt = encodeURIComponent(String(resourceType));
        const rid = encodeURIComponent(String(resourceId));
        const response = await this.client.get(`${this.basePath}/timeline/${rt}/${rid}`, { params });
        return response.data;
    }

    async estimateExport(filters = {}) {
        const response = await this.client.post(`${this.basePath}/export/estimate`, { filters });
        return response.data;
    }

    async exportLogs(data) {
        const response = await this.client.post(`${this.basePath}/export`, data, {
            responseType: data?.format === 'csv' ? 'text' : 'json',
        });
        if (data?.format !== 'csv') return response.data;
        return {
            data: response.data,
            metadata: {
                matchedCount: Number(response.headers?.['x-export-matched-count'] || 0),
                exportableCount: Number(response.headers?.['x-export-exportable-count'] || 0),
                limit: Number(response.headers?.['x-export-limit'] || 0),
                truncated: response.headers?.['x-export-truncated'] === 'true',
            },
        };
    }

    // Plan Faz 9.7 — append-only hash chain integrity + entity activity timeline.
    async verifyIntegrity(params = {}) {
        const response = await this.client.get(`${this.basePath}/integrity/verify`, { params });
        return response.data;
    }

    async getEntityActivity(entityType, entityId, params = {}) {
        const et = encodeURIComponent(String(entityType));
        const eid = encodeURIComponent(String(entityId));
        const response = await this.client.get(`${this.basePath}/activity/${et}/${eid}`, { params });
        return response.data;
    }
}
